/**
 * Umami Custom Events — TCG Collection
 * Tracks: add-to-cart, whatsapp-click, exit-popup-submit, checkout-start,
 *         newsletter-signup, back-in-stock-signup
 */
(function() {
  'use strict';

  function whenReady(fn) {
    if (window.umami) { fn(); return; }
    var t = setInterval(function() {
      if (window.umami) { clearInterval(t); fn(); }
    }, 300);
    setTimeout(function() { clearInterval(t); }, 8000);
  }

  whenReady(function() {

    // ─── Add to Cart (form submit) ───
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (form.action && form.action.indexOf('/cart/add') !== -1) {
        var btn = form.querySelector('[name="id"]');
        var qty = form.querySelector('[name="quantity"]');
        umami.track('add-to-cart', {
          variant_id: btn ? btn.value : 'unknown',
          quantity: qty ? parseInt(qty.value) || 1 : 1,
          page: window.location.pathname
        });
      }
    });

    // ─── Add to Cart (fetch-based, modern themes) ───
    if (window.fetch) {
      var origFetch = window.fetch;
      window.fetch = function() {
        var url = arguments[0];
        if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
          try {
            var opts = arguments[1];
            if (opts && opts.body) {
              var body = typeof opts.body === 'string' ? JSON.parse(opts.body) : null;
              umami.track('add-to-cart', {
                variant_id: body && body.id ? String(body.id) : 'fetch',
                quantity: body && body.quantity ? body.quantity : 1,
                page: window.location.pathname
              });
            }
          } catch(err) {
            umami.track('add-to-cart', { page: window.location.pathname });
          }
        }
        return origFetch.apply(this, arguments);
      };
    }

    // ─── WhatsApp Click ───
    document.addEventListener('click', function(e) {
      var link = e.target.closest('a[href*="wa.me"], a[href*="whatsapp"], .whatsapp-float, .wa-blob');
      if (link) {
        umami.track('whatsapp-click', { page: window.location.pathname });
      }
    });

    // ─── Exit Popup Submit ───
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (form.closest && form.closest('#exit-popup-overlay')) {
        umami.track('exit-popup-submit', { page: window.location.pathname });
      }
    });

    // ─── Newsletter / Customer form ───
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (form.action && form.action.indexOf('/contact') !== -1 && !(form.closest && form.closest('#exit-popup-overlay'))) {
        var tags = form.querySelector('input[name="contact[tags]"]');
        umami.track('newsletter-signup', {
          source: tags ? tags.value : 'footer',
          page: window.location.pathname
        });
      }
    });

    // ─── Checkout Start ───
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"]');
      if (btn) {
        umami.track('checkout-start', { page: window.location.pathname });
      }
    });

    // ─── Back-in-Stock (Avisame) ───
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (form.closest && form.closest('.back-in-stock-form, .bis-form, [data-bis-form]')) {
        umami.track('back-in-stock-signup', { page: window.location.pathname });
      }
    });

  });
})();
